const offPeakClinic = [
  {
    path: '/registration_evening_weekend_clinic',
    name: '夜间·周末门诊',
    alias: '/off_peak_clinic',
    component: () => import('@/pages/offPeakClinic/OffPeakClinicHome.vue')
  },
  {
    path: '/off_peak_clinic_hospital_area',
    name: '选择院区',
    alias: '/registration_off_peak_hospital_area',
    component: () => import('@/pages/offPeakClinic/OffPeakClinicHospitalArea.vue')
  },
  {
    path: '/off_peak_clinic_department',
    name: '科室列表',
    alias: '/registration_off_peak_department',
    component: () => import('@/pages/offPeakClinic/OffPeakClinicDepartment.vue')
  },
  {
    path: '/off_peak_clinic_department_hospitals',
    name: '开放该科室的医院',
    component: () => import('@/pages/offPeakClinic/OffPeakClinicDepartmentHospitals.vue')
  },
  {
    path: '/registration_evening_weekend_clinic_doctors',
    name: '夜间·周末门诊医生',
    component: () => import('@/pages/offPeakClinic/OffPeakClinicDoctorList.vue')
  },
  {
    path: '/registration_evening_weekend_clinic_doctor_detail',
    name: '夜间·周末门诊医生详情',
    component: () => import('@/pages/offPeakClinic/OffPeakClinicDoctorDetail.vue')
  }
]

export default offPeakClinic
